// analyticsSDK.js - React-friendly SDK

const BASE_URL =
  process.env.NODE_ENV === "development"
    ? "https://beta.lntcs.ai/livehubbackend"
    : "https://beta.lntcs.ai/livehubbackend";
const API_TOKEN="3e2f1a9c8d7b6a5f4e3d2c1b0a9f8e7d6c5b4a3f2e1d0c9b8a7f6e5d4c3b2a1f09d8c7";
/**
 * Generic POST helper
 */
async function postData(endpoint, payload) {
  const res = await fetch(`${BASE_URL}${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" ,"Authorization": `Bearer ${API_TOKEN}` },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    throw new Error(`POST ${endpoint} failed: ${res.status}`);
  }
  return res.json();
}

/**
 * Track an event
 * Required: app_id, user_id, event
 * Optional: service, eventType, action, url, timestamp
 */
export async function trackEvent(app_id, user_id, event, options = {}) {
  const payload = {
    app_id,
    user_id,
    event,
    service: options.service || app_id,
    eventType: options.eventType || "custom",
    action: options.action || "",
    url: options.url || window.location.href,
    timestamp: options.timestamp || new Date().toISOString(),
  };

  console.log("Sending payload:", payload); // debug
  return postData("/track", payload);
}

/**
 * Convenience wrappers
 */
export async function trackPageView(app_id, user_id) {
  return trackEvent(app_id, user_id, "page_view", {
    eventType: "view",
    action: `page:${window.location.pathname}`,
  });
}

export async function trackClick(app_id, user_id, elementId) {
  return trackEvent(app_id, user_id, "click", {
    eventType: "click",
    action: `element:${elementId}`,
  });
}
